import { cn } from "@util/helpers";

export const ASEAN_COUNTRY_EMARSYS_LABEL_MAP = [
  {
    label: "Brunei",
    emarsysLabel: "Brunei Darussalam",
  },
  {
    label: "Cambodia",
    emarsysLabel: "Cambodia",
  },
  {
    label: "Indonesia",
    emarsysLabel: "Indonesia",
  },
  {
    label: "Laos",
    emarsysLabel: "Laos",
  },
  {
    label: "Malaysia",
    emarsysLabel: "Malaysia",
  },
  {
    label: "Myanmar",
    emarsysLabel: "Myanmar",
  },
  {
    label: "Philippines",
    emarsysLabel: "Philippines",
  },
  {
    label: "Singapore",
    emarsysLabel: "Singapore",
  },
  {
    label: "Thailand",
    emarsysLabel: "Thailand",
  },
  {
    label: "Timor-Leste",
    emarsysLabel: "East Timor",
  },
  {
    label: "Vietnam",
    emarsysLabel: "Vietnam",
  },
];

export const BUSINESS_SECTORS = [
  {
    value: "AGRICULTURE_FORESTRY_FISHING",
    label: "Agriculture, Forestry & Fishing",
  },
  { value: "CONSTRUCTION_REAL_ESTATE", label: "Construction & Real Estate" },
  { value: "DEFENSE_AEROSPACE", label: "Defense & Aerospace" },
  { value: "EDUCATION_TRAINING", label: "Education & Training" },
  { value: "FINANCIAL_SERVICES", label: "Financial Services" },
  { value: "GOVERNMENT_PUBLIC_SECTOR", label: "Government & Public Sector" },
  { value: "HEALTHCARE_LIFE_SCIENCES", label: "Healthcare & Life Sciences" },
  {
    value: "HOSPITALITY_TOURISM_FOOD_SERVICES",
    label: "Hospitality, Tourism & Food Services",
  },
  { value: "MANUFACTURING_INDUSTRIAL", label: "Manufacturing & Industrial" },
  {
    value: "MEDIA_ENTERTAINMENT_CREATIVE",
    label: "Media, Entertainment & Creative Industries",
  },
  { value: "MINING_ENERGY", label: "Mining & Energy" },
  { value: "PROFESSIONAL_SERVICES", label: "Professional Services" },
  { value: "TECHNOLOGY", label: "Technology" },
  { value: "TELECOMMUNICATIONS", label: "Telecommunications" },
  { value: "TRANSPORT_LOGISTICS", label: "Transportation & Logistics" },
  { value: "WHOLESALE_RETAIL_TRADE", label: "Wholesale & Retail Trade" },
  { value: "OTHERS", label: "Others (please specify)" },
];

export const SENIORITY_LEVELS = [
  {
    value: "EXECUTIVE_LEADERSHIP",
    label: "Executive Leadership (C-suite / Founder / Owner)",
  },
  {
    value: "SENIOR_LEADERSHIP",
    label: "Senior Leadership (Group-level / Regional)",
  },
  {
    value: "MANAGER_TEAM_LEAD",
    label: "Manager / Team Lead",
  },
  {
    value: "JUNIOR_ENTRY_LEVEL",
    label: "Junior / Entry-level",
  },
  {
    value: "PREFER_NOT_TO_SAY",
    label: "Prefer not to say",
  },
];

export const LEGAL_CONSENT =
  'By submitting this form, I consent to the collection, use, disclosure and/or processing of all of my information and personal data provided in this form by SPH Media Limited and its affiliates (collectively, "SPH") as well as their service providers, for the purposes of processing my request for the survey report, conducting market research and data analytics to enable SPH to refine its content offering and deliver a more personalised user experience (including but not limited to survey reports), and for such other purposes reasonably related to the aforesaid and/or as described in the <a href="https://www.sph.com.sg/tnc/privacy" target="_blank" rel="noopener noreferrer">SPH Group Personal Data Protection Notice</a>.*';

export const NEWSLETTER_SIGNUP_CONSENT =
  "Receive insights into the latest trends across Asia with our weekly newsletter Decoding Asia (optional)";

export const FORM_INPUT_PLACEHOLDER =
  "placeholder:text-gray-550 placeholder:text-sm placeholder:font-poppins placeholder:tracking-2%";

export const FORM_DROPDOWN_FOCUS = "border-gray-850";

export const FORM_DROPDOWN_LIST_CONTAINER = {
  item: "hover:bg-gray-75",
  selectedBg: "bg-gray-75",
  selected: "text-blue-175",
};

export const FORM_VARIANT_CLASS_NAME: VariantClassName = {
  placeholder: cn("text-gray-550 text-sm font-poppins tracking-2%"),
  focus:
    "focus:border focus:border-gray-850 focus:rounded-full focus:outline-none",
  errorBorder: "border-red",
  input:
    "border-gray-175 border rounded-full hover:border-gray-850 text-gray-850",
  container: "col-span-1",
  dropdownList: FORM_DROPDOWN_LIST_CONTAINER,
};
